import { motion } from "framer-motion";
import { Network, Users, Building2, Wallet, RefreshCw, Layers } from "lucide-react";
import { useState } from "react";
import Organigramme from "../Organigramme";
import { Button } from "../../../../components/ui/button";

export default function BlocOrganigramme({ type = "Famille", rootId }) {
  const [reloadKey, setReloadKey] = useState(0);

  const handleRefresh = () => {
    setReloadKey(prev => prev + 1);
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="space-y-6"
    >
      {/* En-tête & Légende de l'Arbre */}
      <div className="workspace-card p-5 rounded-[var(--hp-radius-lg)] border border-workspace bg-surface shadow-hp-sm">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex items-start gap-3.5">
            <div className="w-10 h-10 rounded-xl bg-secondary/10 text-secondary flex items-center justify-center shrink-0">
              <Network className="w-5 h-5" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-primary">Arbre Juridique & Participations Patrimoniales</h2>
              <p className="text-sm text-subtle mt-0.5">
                Visualisez la structure hiérarchique reliant le foyer fiscal, les personnes physiques décisionnaires et leurs sociétés détenues.
              </p>
            </div>
          </div>

          <Button 
            variant="outline" 
            size="sm" 
            onClick={handleRefresh}
            className="self-start md:self-auto flex items-center gap-1.5"
          >
            <RefreshCw className="w-3.5 h-3.5" />
            Actualiser l'arbre
          </Button>
        </div>

        {/* Légende interactive */}
        <div className="mt-4 pt-4 border-t border-workspace flex flex-wrap items-center gap-4 text-xs text-subtle">
          <span className="font-semibold text-muted flex items-center gap-1">
            <Layers className="w-3.5 h-3.5" /> Légende :
          </span>
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-info-50 text-info-700 dark:bg-info-900/30 dark:text-info-300 font-medium">
            <Users className="w-3 h-3" /> Foyer Fiscal (IR / IFI)
          </span>
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-surface border border-workspace text-primary font-medium">
            👤 Personnes Physiques (Déclarants & Enfants)
          </span>
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-purple-50 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300 font-medium">
            <Building2 className="w-3 h-3" /> Personnes Morales (IS / SCI)
          </span>
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-success-50 text-success-700 dark:bg-success-900/30 dark:text-success-300 font-medium">
            <Wallet className="w-3 h-3" /> Portefeuilles & Titres
          </span>
        </div>
      </div>

      {/* Conteneur de l'Organigramme */}
      <div className="workspace-card rounded-[var(--hp-radius-lg)] border border-workspace bg-surface shadow-hp-sm overflow-hidden min-h-[500px]">
        <Organigramme key={reloadKey} type={type} rootId={rootId} />
      </div>
    </motion.section>
  );
}
